import PageWrapper from "@/components/layout/page-wrapper";
import TestChatDialog from "@/components/ai-training/test-chat-dialog/test-chat-dialog";
import { Badge } from "@/components/ui/badge";
import { Card } from "@/components/ui/card";
import useSocketMessage from "@/store/socket-message";
import { Link, Outlet, useLocation } from "react-router";
import { cn } from "@/lib/utils";

const valueContainedInLastPath = (pathname: string, value: string) => {
    const lastPath = pathname.split("?")[0].split("/").pop();
    return lastPath === value;
};

const TrainingLayout = () => {
    const { connectionStatus } = useSocketMessage();

    const location = useLocation();
    return (
        <PageWrapper
            pageTitle={`${
                valueContainedInLastPath(location.pathname, "training")
                    ? "Training"
                    : valueContainedInLastPath(location.pathname, "corrections")
                    ? "Corrections"
                    : "Custom Instructions"
            }`}
            currentPage={`${
                valueContainedInLastPath(location.pathname, "training")
                    ? "Training"
                    : valueContainedInLastPath(location.pathname, "corrections")
                    ? "Corrections"
                    : "Custom Instructions"
            }`}
            previousPages={[{ title: "AI Training", url: "/app/ai-training" }]}
        >
            <div className="mb-4 flex flex-col items-stretch gap-4 md:flex-row">
                <Card className="flex-1 border bg-gray-200 shadow-none">
                    <div className="flex w-full  max-w-[calc(100vw-70px)] gap-3 overflow-x-auto p-1  md:overflow-x-hidden">
                        <Link
                            to="knowledge-base"
                            className={cn(
                                valueContainedInLastPath(location.pathname, "knowledge-base") && "bg-white shadow-md border",
                                "rounded-lg px-4 py-2 font-semibold text-gray-600 hover:bg-white text-nowrap"
                            )}
                        >
                            Knowledge Base
                            {connectionStatus === "Connected" && <Badge className="mx-2 bg-green-600">active</Badge>}
                        </Link>
                        {/* <Link
                            to="active-trainings"
                            className={cn(
                                valueContainedInLastPath(location.pathname, "active-trainings") && "bg-white shadow-md border",
                                "rounded-lg px-4 py-2 font-semibold text-gray-600 hover:bg-white text-nowrap"
                            )}
                        >
                            Active Trainings
                        </Link> */}
                        <Link
                            to="training-history"
                            className={cn(
                                valueContainedInLastPath(location.pathname, "training-history") && "bg-white shadow-md border",
                                "rounded-lg px-4 py-2 font-semibold text-gray-600 hover:bg-white text-nowrap"
                            )}
                        >
                            Training History
                        </Link>
                        <Link
                            to="shoe-size-refine"
                            className={cn(
                                valueContainedInLastPath(location.pathname, "shoe-size-refine") && "bg-white shadow-md border",
                                "rounded-lg px-4 py-2 font-semibold text-gray-600 hover:bg-white text-nowrap"
                            )}
                        >
                            Shoe Size Refine
                        </Link>
                        {/* <Link
                            to="corrections"
                            className={cn(
                                valueContainedInLastPath(location.pathname, "corrections") && "bg-white shadow-md border",
                                "rounded-lg px-4 py-2 font-semibold text-gray-600 hover:bg-white text-nowrap"
                            )}
                        >
                            Corrections
                        </Link> */}

                        {/* <Link
                            to="custom-instructions"
                            className={cn(
                                valueContainedInLastPath(location.pathname, "custom-instructions") && "bg-white shadow-md border",
                                "rounded-lg px-4 py-2 font-semibold text-gray-600 hover:bg-white text-nowrap"
                            )}
                        >
                            Custom Instructions
                        </Link> */}
                    </div>
                </Card>
                <div className="flex items-center justify-center rounded-lg bg-gray-200 p-2">
                    <TestChatDialog />
                </div>
            </div>

            <Outlet />
        </PageWrapper>
    );
};

export default TrainingLayout;
